// extracted by mini-css-extract-plugin
export default {"ResourcesList":"ResourcesList_ResourcesList__iUoOm"};